import { useEffect, useRef, useState } from "react";

export function StatCounter({ value, suffix = "", label, duration = 1600 }) {
  const ref = useRef(null);
  const [display, setDisplay] = useState(0);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !started.current) {
        started.current = true;
        if (reduce) {
          setDisplay(value);
          return;
        }
        const start = performance.now();
        const tick = (now) => {
          const p = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - p, 3);
          setDisplay(Math.round(eased * value));
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }
    }, { threshold: 0.5 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [value, duration]);

  return (
    <div ref={ref} data-testid={`stat-${label?.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-foreground tabular-nums">
        {display}
        <span className="text-primary">{suffix}</span>
      </div>
      <div className="mt-2 font-mono-tech text-xs tracking-widest uppercase text-muted-foreground">
        {label}
      </div>
    </div>
  );
}
